/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message, Modal } from "antd";
import moment from "moment";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { buildQueryStringWithObjectParams, toHttpFormatStartOfDay } from "../../lib/utils";
import {
  createProfilesRoute,
  deleteProfilesVersionsRoute,
  serviceProfilesRoute,
  serviceProfilesVersionsRoute,
  updateProfilesVersionsRoute,
} from "../../lib/routes/service-profile";
import Message from "../../components/Message/Message";

const initialState = {
  serviceProfiles: [],
  serviceProfilesLoading: rtkRequestStatusCodes.idle,
  serviceProfilesVersions: [],
  serviceProfilesVersionsLoading: rtkRequestStatusCodes.idle,
};

export const fetchCommonServiceProfiles = createAsyncThunk(
  "service-profile/fetchServiceProfiles",
  async (v, { dispatch }) => {
    const serviceProfilesParams = {
      onDate: toHttpFormatStartOfDay(moment()),
      profileType: "common",
    };
    const queryString = `&${buildQueryStringWithObjectParams(serviceProfilesParams)}`;
    dispatch(fetchServiceProfiles({ queryString }));
  }
);

const fetchServiceProfiles = createAsyncThunk(
  "service-profile/fetchServiceProfiles",
  async ({ queryString }) => {
    const url = [
      serviceProfilesRoute("offerings-api", "service-profiles", "search?"),
      queryString,
    ].join("");

    const response = axios.get(url);
    const { data } = await response;
    const dataSortByDate = data.sort((a, b) => (a.name > b.name ? 1 : -1));
    return dataSortByDate;
  }
);

const fetchServiceProfilesVersions = createAsyncThunk(
  "service-profile/fetchServiceProfilesVersions",
  async ({ id }) => {
    const response = axios.get(serviceProfilesVersionsRoute(id));
    const { data } = await response;
    return data.sort((a, b) => new Date(b.toDate) - new Date(a.toDate));
  }
);

const createProfilesVersion = createAsyncThunk(
  "service-profile/createProfilesVersion",
  // eslint-disable-next-line consistent-return
  async (dataPost) => {
    try {
      message.loading("Сохранение", 0);
      const response = axios.post(createProfilesRoute(), dataPost);
      const { data } = await response;
      message.destroy();
      message.success("Профиль успешно добавлен");
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания", e);
    }
  }
);

const updateProfilesVersion = createAsyncThunk(
  "service-profile/updateProfilesVersion",
  // eslint-disable-next-line consistent-return
  async ({ id, fromDate, force, values }) => {
    try {
      message.loading("Сохранение", 0);
      const response = axios.patch(updateProfilesVersionsRoute(id, fromDate, force), values);
      const { data } = await response;
      message.destroy();
      if (force === true) {
        message.success("Версия успешно обновлёна");
      } else {
        message.success("Версия успешно добавлена");
      }
      return data;
    } catch (e) {
      message.destroy();
      if (force === true) {
        message.error("Ошибка обновления");
      } else {
        message.error("Ошибка добавления");
      }
    }
  }
);

const deleteProfilesVersion = createAsyncThunk(
  "service-profile/deleteProfilesVersion",
  // eslint-disable-next-line consistent-return
  async ({ id, fromDate }) => {
    try {
      message.loading("Изменение даты", 0);
      const response = axios.delete(deleteProfilesVersionsRoute(id, fromDate));
      const { data } = await response;
      message.destroy();
      message.success("Дата успешно обновлёна");
      return data;
    } catch (e) {
      message.destroy();
      Modal.error({
        title: "Ошибка",
        content: `${e.response.data.message}`,
      });
      /* message.error(`Ошибка изменения - ${e.response.data.message}`); */
    }
  }
);

export const slice = createSlice({
  name: "serviceProfile",
  initialState,
  extraReducers: {
    [fetchServiceProfiles.rejected]: (state) => {
      // eslint-disable-next-line no-console
      console.error("Ошибка загрузки общих профилей");
      state.serviceProfiles = [];
      state.serviceProfilesLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceProfiles.fulfilled]: (state, action) => {
      state.serviceProfiles = action.payload;
      state.serviceProfilesLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceProfiles.pending]: (state) => {
      state.serviceProfilesLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceProfilesVersions.fulfilled]: (state, action) => {
      state.serviceProfilesVersions = action.payload;
      state.serviceProfilesVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceProfilesVersions.pending]: (state) => {
      state.serviceProfilesVersionsLoading = rtkRequestStatusCodes.pending;
    },
  },
});

const { reducer } = slice;

export {
  fetchServiceProfiles,
  fetchServiceProfilesVersions,
  createProfilesVersion,
  updateProfilesVersion,
  deleteProfilesVersion,
};

export default reducer;
